export { default } from './es/icons/DeleteTwoTone';